import React, { useEffect, useState } from "react";
import Header from "../../../components/header/Header";
import Button from "../../../components/button/Button";
import "./DepostBank.css";
import { replace, useNavigate } from "react-router-dom";
import axios from "axios";
import { MutatingDots } from "react-loader-spinner";
import { algo } from "react-financial-charts";
import { useTranslation } from "react-i18next";
import ReplenishmentDetailsComponent from "./ReplenishmentDetails";
import {
  checkParams,
  handleCopy,
  fetchCoinsAndAddress,
  getCourse,
  handleBankStatus,
  handleDeposit,
} from "../../Deposit/depositBank/depostBankUtils";
import sber from "./ico/sber.png"
import open from "./ico/Open.png"
import vtb from "./ico/VTB.png"
import alfa from "./ico/alfa.png"

const DepostBank = () => {
  const url = new URL(document.location.href);
  let bankTransferId = url.searchParams.get("bankTransferId");
  let bankAmount = url.searchParams.get("amount");

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedCoin, setSelectedCoin] = useState("Other");
  const [selectedCoin2, setSelectedCoin2] = useState("");
  const [depositAmount, setDepositAmount] = useState("");
  const [depositAddress, setDepositAddress] = useState("");
  const [availableCoins2, setAvailableCoins2] = useState([]);
  const [availableCoins, setAvailableCoins] = useState([]);
  const [availableCoinCurruency, setAvailableCoinCurruency] = useState();
  const [availableCoinsCurruency, setAvailableCoinsCurruency] = useState(
      [
          {
              "cryptoTransferVar": "RUB",
              "cryptoNet": "₽",
              "cryptoCardNumber": ""
          },
          {
              "cryptoTransferVar": "USD",
              "cryptoNet": "$",
              "cryptoCardNumber": ""
          },
          {
              "cryptoTransferVar": "EUR",
              "cryptoNet": "€",
              "cryptoCardNumber": ""
          },
          {
              "cryptoTransferVar": "Fr",
              "cryptoNet": "₣",
              "cryptoCardNumber": ""
          },
      ]
  );
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const token = localStorage.getItem("token");

  const [showBankTransfer, setShowBankTransfer] = useState(false);
  const [isContinued, setIsContinued] = useState(false);
  const [idbk, setIdbk] = useState();

  const [walletbk, setWalletbk] = useState("");
  const [bankTransferREKS, setBankTransferDepREKS] = useState("");
  const [qrCodeImage, setQrCodeImage] = useState("");
  const [isContinuedSS, setIsContinuedSS] = useState(false);
  const [HdnppBANK, setHdnppBANK] = useState(false);
  const [sumInRub, setSumInRub] = useState("")

  useEffect(()=>{
    setSumInRub(Math.floor(depositAmount * cursCb))
  }, [depositAmount])
  useEffect(() => {
    const setFunctions = {
      setIsContinued,
      setIdbk,
      setShowBankTransfer,
      setDepositAmount,
    };
    checkParams(bankTransferId, bankAmount, setFunctions);
  }, [bankTransferId, bankAmount]);

  // Обновляем адрес депозита при изменении выбранной криптовалюты
  useEffect(() => {
    if (selectedCoin == "Other") {
    } else if (selectedCoin) {
      const coinData = availableCoins.find(
        (coin) => coin.bankTransferVar === selectedCoin
      );
      setDepositAddress(coinData.bankCardNumber || ""); // Если не найдено, будет пустая строка
    }
  }, [selectedCoin]);

  // Загружаем данные при монтировании
  useEffect(() => {
    fetchCoinsAndAddress(setAvailableCoins, setLoading, token);
  }, [token]);

  const [cursCb, setCursCb] = useState(0);
  // Обработчик отправки депозита
  const handleConfirmPayment = () => {
    setHdnppBANK(true);
  };

  useEffect(() => {
    if (idbk != null && idbk != undefined && idbk != "") {
      handleBankStatus(idbk, {
        setIsContinuedSS,
        setWalletbk,
        setBankTransferDepREKS,
        setQrCodeImage
      });
    }
  }, [idbk]);

  const handleBankStatusAfterAll = () => {
    axios
      .get(`https://api-ru.fynex.cc/api/api/refill/bank/status?id=${idbk}`)
      .then((res) => {
        if (res.data === "accepted") {
          navigate(`../transactions`, { replace: true });
        } else if (res.data === "waiting") {
          setTimeout(() => handleBankStatusAfterAll(), 2000);
        }
      })
      .catch((err) => {
        console.error(err);
        setTimeout(() => handleBankStatusAfterAll(), 2000);
      });
  };

  useEffect(() => {
    if (HdnppBANK) {
      handleBankStatusAfterAll();
    }
  }, [HdnppBANK]);

  useEffect(() => {
    getCourse(setCursCb);
  }, []);

  const isLoaderActive = (isContinued && !isContinuedSS) || HdnppBANK;

  const hasBottomFields =
    !!bankTransferREKS.bank ||
    !!bankTransferREKS.name ||
    !!bankTransferREKS.comment ||
    !!walletbk;

  const shouldHideInputs = isLoaderActive || hasBottomFields;

  const transformCryptoData2 = (data) => {
        const result = [];

        // Проходим по ключам объекта
        for (let i = 1; i <= 5; i++) {
            if (data[`cryptoEnabled${i}`]) {
                result.push({
                    [`cryptoTransferVar`]: data[`cryptoTransferVar${i}`],
                    [`cryptoNet`]: data[`cryptoNet${i}`],
                    [`cryptoCardNumber`]: data[`cryptoCardNumber${i}`],
                });
            }
        }

        return result;
    };

  // Получение списка доступных криптовалют
  const fetchCoinsAndAddress2 = async () => {
      setLoading2(true);
      axios.get(`https://api-ru.fynex.cc/api/api/crypto/avilable`, {headers: {'Authorization': `Bearer ${token}`}})
          .then(res => {
              setAvailableCoins2(transformCryptoData2(res.data))
              setLoading2(false);
          })
          setLoading2(true);
  };
  useEffect(() => {
      // fetchCoinsAndAddress2();
    }, []);

  return (
    <div className="DepositBank">
      <Header hasMenu2={true} />

      <div className="DepositBankWrapper">
        {true && (
          // {!bankTransferId && (
          <div
            className={`replenishment  ${
              !shouldHideInputs ? "" : "withInputs"
            }`}
          >
            <h2>{t("depositBank.paymentFiat")}</h2>
            {!shouldHideInputs && (
              <div className="input">
                <select
                            value={availableCoinCurruency}
                            onChange={(e) => setAvailableCoinCurruency(e.target.value)}
                        >
                            {loading2 ? (
                                ""
                            ) : (

                                <option value="" disabled>
                                    {t("depositCrypto.selectCoin")}
                                </option>
                            )
                            }
                            {loading2 ? (
                                <option value="" disabled>
                                    {t("depositCrypto.loading")}
                                </option>
                            ) : (
                                availableCoinsCurruency.map((coin) => (
                                    <option key={coin.cryptoTransferVar} value={coin.cryptoTransferVar}>
                                        {coin.cryptoTransferVar.toUpperCase()} ({coin.cryptoNet})
                                    </option>
                                ))
                            )}

                        </select>
                <div className="selectClass" style={{display: 'none'}}>
                  <div className="selectImg">
                      { selectedCoin == "Банк Сбербанк" && <img src={sber}/> }
                      { selectedCoin == "Банк Альфа-Банк" && <img src={alfa}/> }
                      { selectedCoin == "Банк ВТБ" && <img src={vtb}/> }
                      { selectedCoin == "Банк Открытие" && <img src={open}/> }
                  </div>
                  <select
                    value={selectedCoin}
                    onChange={(e) => setSelectedCoin(e.target.value)}
                  >
                    {loading ? (
                      ""
                    ) : (
                      <option value="" disabled>
                        {t("depositBank.selectBank")}
                      </option>
                    )}
                    {loading ? (
                      <option value="" disabled>
                        {t("depositBank.load")}
                      </option>
                    ) : (
                      <>
                        {console.log(availableCoins)}
                        {availableCoins.filter(item => item.bankTransferVar != "Другое").map((coin) => (
                          <option
                            key={coin.bankTransferVar}
                            value={coin.bankTransferVar}
                          >
                            {coin.bankTransferVar}
                          </option>
                        ))}
                        <option value={"Other"}>{t("depositBank.other")}</option>
                      </>
                    )}
                  </select>
                </div>

                <input
                  type={selectedCoin === "Other" ? "text" : "hidden"}
                  placeholder={t("depositBank.specifyBank")}
                  value={selectedCoin2}
                  onChange={(e) => setSelectedCoin2(e.target.value)}
                />
                <input
                  type="text"
                  placeholder={t("depositBank.specifySum")}
                  value={depositAmount}
                  onChange={(e) =>
                    setDepositAmount(e.target.value.replace(/[^\d.]|(?<=\.\d*)\./g, ""))
                  }
                />
              </div>
            )}
          </div>
        )}

        {isContinued && !isContinuedSS && (
          <div className={`ReplenishmentDetails`}>
            <div className="mr10">
              {/* {t("depositBank.notOnloadPage")} */}
              <MutatingDots
                visible={true}
                height="100"
                width="100"
                color="#f3f3f3"
                secondaryColor="#fff"
                radius="12.5"
                ariaLabel="mutating-dots-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          </div>
        )}

        {HdnppBANK && (
          <div className={`ReplenishmentDetails`}>
            <div className="mr10">
              {/* {t("depositBank.notOnloadPage")} */}
              <MutatingDots
                visible={true}
                height="100"
                width="100"
                color="#f3f3f3"
                secondaryColor="#fff"
                radius="12.5"
                ariaLabel="mutating-dots-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          </div>
        )}

        {isContinuedSS && !HdnppBANK && (
          // {true && (
          <div className="Details">
            <ReplenishmentDetailsComponent
              depositAddress={depositAddress}
              bankTransferREKS={bankTransferREKS}
              walletbk={walletbk}
              handleCopy={handleCopy}
              handleConfirmPayment={handleConfirmPayment}
              showConfirmButton={false}
              summ={bankAmount}
              qrCodeImage={qrCodeImage}
            />
          </div>
        )}

        {!isContinuedSS && !isContinued && (
          <div className="ReplenishmentDetails">
            <Button
              classname="dep-btn"
              onClick={(e) =>
                handleDeposit({
                  selectedCoin,
                  depositAmount,
                  selectedCoin2,
                  cursCb,
                  token,
                  navigate,
                  t,
                  setIdbk,
                  setIsContinuedSS,
                  setIsContinued,
                })
              }
              text={`${t("depositBank.deposit")} ${
                depositAmount ? `(${sumInRub} RUB)` : ""
              }`}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DepostBank;
